import { Route, Routes } from 'react-router-dom';
import {
  MonitoringDashboard,
} from '@/capabilities/monitoring-alerts/public/routes/lazyPages';
import {
  WorkbenchShell,
} from '@/capabilities/service-operations/public/routes/lazyPages';
import { destinationCapabilityRouteElements } from '@/app/navigation/routes/capabilities/destinationCapabilityRegistry';

export function WorkbenchRoutes() {
  return (
    <Routes>
      <Route index element={<WorkbenchShell />} />
      <Route path="monitoring" element={<MonitoringDashboard />} />
      {destinationCapabilityRouteElements('workbench')}
    </Routes>
  );
}
